import { Activity, useEffect } from 'react';
import {
  ButtonSecondary,
  ButtonSize,
  IconArrowLeft,
  IconArrowRight,
  IconDown,
  IconUp,
} from '@ui/src';
import { MarginsTopTypes } from '../types';

import cn from '../styles.module.css';

let focusTimeout: NodeJS.Timeout;

const MarginsTop = ({
  allMarginsVisible,
  setAllMarginsVisible,
  setSelectedCurrency,
  currencies,
  currenciesList,
  showMoreCurrencies,
  selectedCurrency,
  onAllMarginsCurrencyFilter,
  setShowMoreCurrencies,
  setMenuOnFocus,
  menuOnFocus,
}: MarginsTopTypes) => {
  useEffect(() => {
    if (showMoreCurrencies && !menuOnFocus) {
      focusTimeout = setTimeout(() => {
        setShowMoreCurrencies(false);
      }, 2000);
    }
  }, [showMoreCurrencies, menuOnFocus]);

  return (
    <>
      <Activity mode={allMarginsVisible ? 'visible' : 'hidden'}>
        <button
          type="button"
          className={cn.marginsBackButton}
          onClick={() => {
            setAllMarginsVisible(false);
            setSelectedCurrency('');
          }}
        >
          <IconArrowLeft width={13} height={11} />
          Back to Tariff
        </button>
      </Activity>
      <div className={cn.marginsTitleWrapper}>
        <div className={cn.marginsTitle}>FX margin</div>
        <Activity mode={allMarginsVisible ? 'hidden' : 'visible'}>
          <ButtonSecondary
            size={ButtonSize.SMALL}
            text="See all"
            icon={<IconArrowRight />}
            onClick={() => {
              setAllMarginsVisible(true);

              if (currencies) {
                setSelectedCurrency(currencies[0].value as string);
              }
            }}
            className={`button-white ${cn.allMarginsButton}`}
            iconPosition="right"
          />
        </Activity>
      </div>
      <Activity mode={allMarginsVisible ? 'visible' : 'hidden'}>
        <div className={cn.currenciesTabsWrapper}>
          <div className={cn.currenciesListWrapper}>
            {currenciesList?.slice(0, 7)?.map((item) => (
              <button
                key={item.id}
                type="button"
                className={`${cn.currencyTab} ${
                  selectedCurrency === item.id ? cn.active : ''
                }`}
                onClick={() => onAllMarginsCurrencyFilter(item.id)}
              >
                {item.name}
              </button>
            ))}
            {currenciesList && currenciesList?.length > 7 && (
              <div className={cn.moreCurrenciesWrapper}>
                <button
                  type="button"
                  className={`${cn.moreCurrenciesButton} ${cn.currencyTab} ${
                    showMoreCurrencies ? cn.active : ''
                  }`}
                  onMouseEnter={() => {
                    setShowMoreCurrencies(true);
                    setMenuOnFocus(true);
                  }}
                  onMouseLeave={() => setMenuOnFocus(false)}
                >
                  More {!showMoreCurrencies ? <IconDown /> : <IconUp />}
                </button>
                {showMoreCurrencies && (
                  <ul
                    onMouseEnter={() => {
                      setMenuOnFocus(true);
                      clearTimeout(focusTimeout);
                    }}
                    className={cn.moreCurernciesList}
                    onMouseLeave={() => {
                      setShowMoreCurrencies(false);
                      clearTimeout(focusTimeout);
                    }}
                  >
                    {currenciesList?.slice(7).map((item) => (
                      <li key={item.id}>
                        <button
                          type="button"
                          onClick={() => onAllMarginsCurrencyFilter(item.id)}
                          className={
                            selectedCurrency === item.id ? cn.active : ''
                          }
                        >
                          {item.name}
                        </button>
                      </li>
                    ))}
                  </ul>
                )}
              </div>
            )}
          </div>
        </div>
      </Activity>
    </>
  );
};

export default MarginsTop;
